import React from 'react';
import PropTypes from 'prop-types';
import {
  CardMedia,
  Typography,
  CardTitle,
  Button,
} from '@one-thd/sui-atomic-components';
import ProjectsHeader from '../ProjectsHeader';
import NullStateCreateProjectAction from './NullStateCreateProjectAction';
import nullStateConstants from '../../constants/nullStateConstants';
import { triggerProjectsInteractionAnalytics } from '../../utils/helpers';

const MobileNullView = ({
  componentId, isDashboardSnapshot
}) => {
  const {
    cardTitle,
    bodyText,
    imageAlt,
    imageUrl,
    buttonText,
    buttonTextDesktop,
    learnMoreText,
    learnMoreLink,
  } = nullStateConstants;

  return (
    <div
      data-component="Projects"
      data-testid="projects-null-container"
      className="sui-flex sui-flex-col sui-h-full"
    >
      {/*
        Dashboard Snapshot: no header row, like the desktop view, since the tab already names the
        tool. Learn More moves from the header into a button beside Create New, keeping the
        header link's analytics.
      */}
      {!isDashboardSnapshot && (
        <ProjectsHeader
          actions={['learnMore']}
          componentId={componentId}
        />
      )}
      <div className="sui-flex sui-flex-col sui-h-full">
        <div className={isDashboardSnapshot ? 'sui-rounded-md sui-overflow-hidden' : 'sui-mt-4'}>
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            aspect="wide"
          />
        </div>
        <div className="sui-mt-5">
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
          />
        </div>
        <div className="sui-mt-1">
          <Typography>
            {bodyText}
          </Typography>
        </div>
        <div className="sui-mt-auto sui-pt-4">
          {isDashboardSnapshot ? (
            <div className="sui-flex sui-gap-4">
              <div className="sui-flex-1">
                <Button
                  variant="secondary"
                  fullWidth
                  href={learnMoreLink}
                  onClick={() => triggerProjectsInteractionAnalytics({
                    action: 'clickthrough',
                    component: 'null state learn more',
                    id: componentId,
                  })}
                >
                  {learnMoreText}
                </Button>
              </div>
              <div className="sui-flex-1">
                <NullStateCreateProjectAction
                  cacheKey="mobile-null-view-create-project"
                  componentId={componentId}
                  buttonText={buttonTextDesktop}
                />
              </div>
            </div>
          ) : (
            <NullStateCreateProjectAction
              cacheKey="mobile-null-view-create-project"
              componentId={componentId}
              buttonText={buttonText}
            />
          )}
        </div>
      </div>
    </div>
  );
};

MobileNullView.propTypes = {
  componentId: PropTypes.string,
  isDashboardSnapshot: PropTypes.bool,
};
MobileNullView.defaultProps = {
  componentId: '',
  isDashboardSnapshot: false,
};

export default MobileNullView;
